import { HeaderProps } from "../../types";
import Button from "../button/Button";
import { MyHeader, HeaderText } from "./Header.styles";

function Header(props: HeaderProps) {
  const { text, goBack, showBtn, handleClick, loading } = props;
  return (
    <MyHeader>
      <HeaderText>{text}</HeaderText>
      {showBtn && (
        <Button
          text={loading ? "Please Wait" : "Save Changes"}
          disabled={Boolean(loading)}
          style={{
            width: "150px",
            height: "36px",
            padding: "10px 20px",
            fontSize: "14.5px",
          }}
          onClick={handleClick ? handleClick : () => {}}
        />
      )}
    </MyHeader>
  );
}

export default Header;
